export const PermissionInstitucional = {
    PUT: "mgr-institutional-**-PUT",
    POST: "mgr-institutional-POST",
    DELETE: "mgr-institutional-**-DELETE",
    GET: "mgr-institutional-search-**-GET",
    GET_UUID: "mgr-institutional-**-GET"
};